import { useCallback, useState, type ReactNode } from "react";
import MarketingHeader from "@/components/MarketingHeader";
import MarketingFooter from "@/components/MarketingFooter";
import ProductHuntLaunchBanner, { PRODUCT_HUNT_LAUNCH_END } from "@/components/ProductHuntLaunchBanner";

interface MarketingLayoutProps {
  children: ReactNode;
  /** Full-bleed heroes that handle their own top padding */
  heroPage?: boolean;
  /** Single-screen home: no footer, constrained to one viewport (100svh) */
  minimal?: boolean;
}

export default function MarketingLayout({ children, heroPage, minimal }: MarketingLayoutProps) {
  const [showLaunchBanner, setShowLaunchBanner] = useState(() => Date.now() < PRODUCT_HUNT_LAUNCH_END);
  const handleLaunchBannerExpired = useCallback(() => setShowLaunchBanner(false), []);

  return (
    <div className={`landing-theme landing-light ${minimal ? "landing-home-shell" : "min-h-screen"} ${showLaunchBanner ? "marketing-has-product-hunt-banner" : ""}`}>
      {showLaunchBanner && <ProductHuntLaunchBanner onExpired={handleLaunchBannerExpired} />}
      <MarketingHeader />
      {!heroPage && !minimal && <div className="h-16 md:h-18" />}
      {children}
      {!minimal && <MarketingFooter />}
    </div>
  );
}
